import { apiGet, apiPost, apiPut, apiDelete, unwrapPaginated, unwrapData } from './helpers'

/**
 * @param {string} lanePath - `weightloss/appointments` | `insurance/weightloss/appointments`
 */
export function createAppointmentsApi(lanePath) {
  return {
    listPaginated: (perPage = 10, params = {}, page = 1) =>
      apiGet(`${lanePath}/${Number(perPage) || 10}`, {
        ...params,
        page: Number(page) || 1,
      }).then(unwrapPaginated),
    getById: id => apiGet(`${lanePath}/detail/${id}`).then(unwrapData),
    create: data => apiPost(lanePath, data),
    update: (id, data) => apiPut(`${lanePath}/detail/${id}`, data),
    remove: id => apiDelete(`${lanePath}/detail/${id}`),
  }
}

const wlAppointmentsApi = createAppointmentsApi('weightloss/appointments')
export const wlAppointmentsInsuranceApi = createAppointmentsApi(
  'insurance/weightloss/appointments'
)

export default wlAppointmentsApi
